import React, { FC } from 'react'
import CollectionPolaroidList from './components/CollectionPolaroidList'
import { SAArtwork } from 'types/Artwork'
import styles from './CollectionDetails.module.scss'
import classNames from 'classnames'
import CollectionDetailsHeader from './components/CollectionDetailsHeader'
import CollectionDetailsActions from './components/CollectionDetailsActions'
import { AdminUrlLinks } from './types'
import CollectionPaginationHitsPerPage from './components/CollectionPaginationHitsPerPage'
import FeedbackModal from './components/FeedbackModal'
import { getIsAdmin } from 'selectors/user/session'
import { useSelector } from 'react-redux'

type CollectionDetailsProps = {
  nextAppRoute: string
  artworks: ReadonlyArray<SAArtwork>
  collectionTitle: string
  collectionDescription: string
  collectionOwnerName: string
  collectionOwnerAvatarUrl: string
  collectionOwnerId: string
  collectionCount: number
  ownerTitle?: string
  idUserCollection: number
  algoliaIndice: string
  adminUrlLinks: AdminUrlLinks
  customActions?: (artwork: SAArtwork) => JSX.Element
  dataList?: 'collection-detail' | 'aa-selection'
  urlPathString: string
}

const CollectionDetails: FC<CollectionDetailsProps> = ({
  nextAppRoute,
  artworks,
  collectionTitle,
  collectionDescription,
  collectionOwnerName,
  collectionOwnerAvatarUrl,
  collectionOwnerId,
  collectionCount,
  ownerTitle,
  idUserCollection,
  algoliaIndice,
  adminUrlLinks,
  customActions,
  dataList,
  urlPathString,
}) => {
  const isAASelection = dataList === 'aa-selection'
  const isAdmin = useSelector(getIsAdmin)

  return (
    <div className={styles.collectionDetailsWrapper}>
      <div className={styles.collectionDetailsPaddingContainer}>
        <CollectionDetailsHeader
          title={collectionTitle}
          subCopy={collectionDescription}
          collectionOwnerName={collectionOwnerName}
          collectionOwnerAvatarUrl={collectionOwnerAvatarUrl}
          collectionOwnerId={collectionOwnerId}
          collectionCount={collectionCount}
          ownerTitle={ownerTitle}
        />
      </div>

      <div className={styles.collectionDetailsPaddingContainer}>
        <CollectionDetailsActions
          adminUrlLinks={adminUrlLinks}
          idUserCollection={idUserCollection}
        />
      </div>

      <div className={styles.mainContentGrid}>
        <div className={classNames(styles.right, styles.fullGrid)}>
          <CollectionPolaroidList
            artworks={artworks}
            collectionTitle={collectionTitle}
            algoliaIndice={algoliaIndice}
            customActions={customActions}
            dataList={dataList}
          />
        </div>
      </div>

      <div
        className={classNames(styles.paginationSection, styles.collectionDetailsPaddingContainer)}
      >
        <CollectionPaginationHitsPerPage
          nextAppRoute={nextAppRoute}
          urlPathString={urlPathString}
        />
      </div>

      {isAASelection && (
        <FeedbackModal
          isAdmin={isAdmin}
          collectionOwnerName={collectionOwnerName}
          idUserCollection={idUserCollection}
        />
      )}
    </div>
  )
}

export default CollectionDetails
